import type {
  IntercomContact,
  IntercomContactsParams,
  IntercomContactsResponse,
  IntercomTag,
} from '@brand24-original/llm-types';
import { client } from '../../../services/apiClient';

const ENDPOINT = '/admin/intercom';

export const getIntercomContacts = async (
  params: IntercomContactsParams
): Promise<IntercomContactsResponse> => {
  const search = new URLSearchParams();
  if (params.query) search.set('query', params.query);
  if (params.tagIds?.length) search.set('tagIds', params.tagIds.join(','));
  if (params.cursor) search.set('cursor', params.cursor);

  const { data } = await client(true, true).get<IntercomContactsResponse>(
    `${ENDPOINT}/contacts?${search.toString()}`
  );
  return data;
};

export const getIntercomContact = async (contactId: string): Promise<IntercomContact> => {
  const { data } = await client(true, true).get<IntercomContact>(
    `${ENDPOINT}/contacts/${contactId}`
  );
  return data;
};

export const getIntercomTags = async (): Promise<IntercomTag[]> => {
  const { data } = await client(true, true).get<IntercomTag[]>(`${ENDPOINT}/tags`);
  return data;
};
